export const BASE_URL_CULK =
  process.env.REACT_APP_BACKEND_API_URL + "/api/v1/user-token-creation";

